import { CardComponent } from '../../shared/components/card/card.component';
import { Component, inject } from '@angular/core';
import { Button } from '../../shared/components/button/button.component';
import { Titledescription } from '../../shared/components/titledescription/titledescription.component';
import { Table } from '../../shared/components/table/table.component';
import { RouterModule } from '@angular/router';
import { PLANES_ACTIONS, PLANES_COLUMN_NAMES, PLANES_FIELDS_CONFIG, PLANES_PAGINATE_OPTIONS } from '../../constants/planes.constants';
import { BaseList } from '../../shared/baseList.component';
import { PlanesService } from '../../core/planes.service';
import { PlanInterface } from '../../models/plan.model';
import { NivelService } from '../../core/nivel.service';

@Component({
  selector: 'app-planes',
  imports: [CardComponent, Table, Button, RouterModule, Titledescription],
  templateUrl: './planes.html',
  styleUrl: './planes.scss'
})
export class Planes extends BaseList<PlanInterface> {
  apiService = new PlanesService;
  columnNames = PLANES_COLUMN_NAMES;
  fields = PLANES_FIELDS_CONFIG;
  actions = PLANES_ACTIONS;
  paginateOptions = PLANES_PAGINATE_OPTIONS;
  entityKey = 'planes';
  dataSelectNiveles: any[] = [];
  nivelService = inject(NivelService);
  override ngOnInit(): void {
    super.ngOnInit();
    this.fieldToFilter = '';
    this.valueToFilter = null;
    this.getNiveles();
  }
  getNiveles() {
    this.nivelService.getAllForSelect().subscribe((data) => {
      this.dataSelectNiveles = data
    });
  }
}
